import React from 'react'
import Index from '../container/index'

const IndexPage = ({ location }) => (
  <Index location={location} langKey='de' />
)

export default IndexPage
